import { brand as pack } from '@brand';
import type { BrandPack } from '../../brands/brand-pack';

/** The brand pack selected at build time. App code reads it from here, never from `@brand`. */
export const brand: BrandPack = pack;
